import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    freezeCard,
    freezeCardSuccess,
    freezeCardError,
    freezeCardReset,
    unfreezeCard,
    unfreezeCardSuccess,
    unfreezeCardError,
    unfreezeCardReset,
} from '@perpay-web/fintech/actions/ui/cardFreeze';

const FreezeCardDataModule = createDataModule({
    dataRequest: freezeCard,
    dataSuccess: freezeCardSuccess,
    dataError: freezeCardError,
    dataReset: freezeCardReset,
});

const UnfreezeCardDataModule = createDataModule({
    dataRequest: unfreezeCard,
    dataSuccess: unfreezeCardSuccess,
    dataError: unfreezeCardError,
    dataReset: unfreezeCardReset,
});

const getFreezeRoot = (state) => state.dataModules.freezeCard;
const getUnfreezeRoot = (state) => state.dataModules.unfreezeCard;
const initialValue = { success: false };

export const freezeCardDataModule = FreezeCardDataModule({
    getRoot: getFreezeRoot,
    initialValue,
});

export const unfreezeCardDataModule = UnfreezeCardDataModule({
    getRoot: getUnfreezeRoot,
    initialValue,
});

export const getFreezeCardSuccess = (state) =>
    freezeCardDataModule.getData(state).success || false;

export const getFreezeCardErrors = (state) =>
    freezeCardDataModule.getErrors(state);

export const getUnfreezeCardSuccess = (state) =>
    unfreezeCardDataModule.getData(state).success || false;

export const getUnfreezeCardErrors = (state) =>
    unfreezeCardDataModule.getErrors(state);
